/**
 * The scope key that marks a Cova Staff firm on the platform (spec
 * multi-product 020 G43, G44 (3)), read from ONE place: the platform scope
 * registry.
 *
 * It is the registry's own lookup, not a literal the staff shell mount trusts on
 * its own. `normalisePlatformScope` answers `None` for a scope the registry
 * does not list. The `staff` row joined `PlatformScopeLiteral` in STAFF-FLIP
 * (spec multi-product 025), so this is `Some("staff")` and the staff shell frame
 * (`platformStaffShellMount`) arms for every person who belongs to a staff
 * firm, with no edit here.
 */
import type { Option } from "effect"

import { normalisePlatformScope, type PlatformScope } from "@/domain/scope/platform-scope"

export const PLATFORM_STAFF_SCOPE: Option.Option<PlatformScope> = normalisePlatformScope("staff")
